var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCheckers(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-checkers"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16398_17402)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 34624872",
    d: "M-1 0H15.5161V16.5161H-1V0Z",
    fill: "#CECECE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 34624874",
    d: "M15.5161 16.5156H32.0322V33.0318H15.5161V16.5156Z",
    fill: "#CECECE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 34624876",
    d: "M-1 33.0332H15.5161V49.5493H-1V33.0332Z",
    fill: "#CECECE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 34624873",
    d: "M15.5161 0H32.0322V16.5161H15.5161V0Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 34624875",
    d: "M-1 16.5156H15.5161V33.0318H-1V16.5156Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 34624877",
    d: "M15.5161 33.0332H32.0322V49.5493H15.5161V33.0332Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 34624872_2",
    d: "M32.0322 0H48.5484V16.5161H32.0322V0Z",
    fill: "#CECECE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 34624875_2",
    d: "M32.0322 16.5156H48.5484V33.0318H32.0322V16.5156Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 34624876_2",
    d: "M32.0322 33.0332H48.5484V49.5493H32.0322V33.0332Z",
    fill: "#CECECE"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16398_17402"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 6,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheckers);
export default __webpack_public_path__ + "static/media/icon-checkers.b09a7d0814afa90150756f9eb4a1880f.svg";
export { ForwardRef as ReactComponent };